/* ==========================================================================
   Ücretsiz Kargo İlerleme Çubuğu — davranış
   - Dolum animasyonu (re-render'lar arası akıcı geçiş)
   - Eşik aşılınca tek seferlik konfeti
   - Hızlı-ekle ("+ Ekle") AJAX sepete ekleme + drawer'ı tazeleme
   Bağımlılık yok (konfeti elle yazılmış canvas).
   ========================================================================== */
(function () {
  'use strict';

  if (window.customElements && window.customElements.get('free-shipping-bar')) return;

  /* ---------- Minik konfeti ---------- */
  function confettiBurst() {
    var canvas = document.createElement('canvas');
    canvas.className = 'fsb-confetti-canvas';
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    var dpr = window.devicePixelRatio || 1;
    var W = (canvas.width = window.innerWidth * dpr);
    var H = (canvas.height = window.innerHeight * dpr);
    ctx.scale(dpr, dpr);

    var colors = ['#11998e', '#38ef7d', '#ffd34e', '#ff7a59', '#5b8def', '#ffffff'];
    var count = window.innerWidth < 750 ? 70 : 110;
    var originX = window.innerWidth / 2;
    var originY = window.innerHeight * 0.32;
    var parts = [];
    for (var i = 0; i < count; i++) {
      var angle = Math.PI * 2 * (i / count);
      var speed = 4 + Math.random() * 7;
      parts.push({
        x: originX,
        y: originY,
        vx: Math.cos(angle) * speed * (0.6 + Math.random()),
        vy: Math.sin(angle) * speed * (0.6 + Math.random()) - 3,
        size: 4 + Math.random() * 5,
        color: colors[(Math.random() * colors.length) | 0],
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.3,
        life: 0
      });
    }

    var maxLife = 75;
    function frame() {
      ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
      var alive = false;
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        if (p.life > maxLife) continue;
        alive = true;
        p.life++;
        p.vy += 0.22; // yerçekimi
        p.vx *= 0.99;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        ctx.save();
        ctx.globalAlpha = Math.max(0, 1 - p.life / maxLife);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
        ctx.restore();
      }
      if (alive) {
        requestAnimationFrame(frame);
      } else if (canvas.parentNode) {
        canvas.parentNode.removeChild(canvas);
      }
    }
    requestAnimationFrame(frame);
  }

  /* ---------- Çubuk custom element ---------- */
  class FreeShippingBar extends HTMLElement {
    connectedCallback() {
      var percent = parseFloat(this.dataset.percent);
      if (isNaN(percent)) percent = 0;
      var unlocked = this.dataset.unlocked === 'true';
      var fill = this.querySelector('.fsb__fill');

      if (fill) {
        var prev = typeof window.__fsbPrevPercent === 'number' ? window.__fsbPrevPercent : null;
        if (prev !== null && prev !== percent) {
          // Sepet değişti → önceki yüzdeden hedefe akıcı animasyon
          fill.style.transition = 'none';
          fill.style.width = prev + '%';
          void fill.offsetWidth; // reflow
          fill.style.transition = '';
          var setTarget = function () {
            fill.style.width = percent + '%';
          };
          requestAnimationFrame(setTarget);
          setTimeout(setTarget, 60); // animasyon kesinlikle hedefe ulaşsın
        } else {
          // İlk render → çubuk anında dolu görünsün (gri kalmasın)
          fill.style.transition = 'none';
          fill.style.width = percent + '%';
          void fill.offsetWidth;
          fill.style.transition = '';
        }
      }
      window.__fsbPrevPercent = percent;

      // Eşik aşıldı anında tek seferlik konfeti (sayfa yenilense de tekrarlamaz)
      var wasUnlocked = false;
      try {
        wasUnlocked = sessionStorage.getItem('fsbUnlocked') === '1';
      } catch (e) {
        /* yoksay */
      }
      if (unlocked && !wasUnlocked) {
        try {
          confettiBurst();
        } catch (e) {
          /* yoksay */
        }
      }
      try {
        sessionStorage.setItem('fsbUnlocked', unlocked ? '1' : '0');
      } catch (e) {
        /* yoksay */
      }
    }
  }
  window.customElements.define('free-shipping-bar', FreeShippingBar);

  /* ---------- Hızlı-ekle (event delegation) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.fsb-card__add') : null;
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';

    var addUrl =
      typeof routes !== 'undefined' && routes.cart_add_url ? routes.cart_add_url : '/cart/add';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (res) {
        btn.textContent = '✓ Eklendi';

        // Sepet sayfasındaysak sayfayı tazele; drawer'daysak drawer'ı yeniden render et.
        if (document.getElementById('main-cart-items')) {
          window.location.reload();
          return;
        }

        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && res.sections && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(res);
        }

        if (
          typeof publish === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined' &&
          PUB_SUB_EVENTS.cartUpdate
        ) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'free-shipping-bar',
            cartData: res
          });
        }
      })
      .catch(function () {
        btn.textContent = original;
        btn.disabled = false;
      });
  });
})();
